/* eslint-disable no-undef */
export const toMoney = (amount, symbol, dp = 2) => {
    return (
        (amount < 0 ? "-" : "") +
        (symbol || "₦") +
        (Math.abs(amount) || 0).toFixed(dp).replace(/\d(?=(\d{3})+\.)/g, "$&,")
    );
};

export function formatSeconds(sec) {
    return parseInt((sec % 3600) / 60) > 0
        ? parseInt((sec % 3600) / 60) +
                "hr " +
                parseInt((sec % 3600) % 60) +
                "min"
        : parseInt((sec % 3600) % 60) + "min";
}


// save data to local storage
export function saveToStorage(data) {
    try {
        var saveData = JSON.parse(localStorage.saveData || null) || {};
        saveData[data.name] = data.value;
        saveData.time = new Date().getTime();
        localStorage.saveData = JSON.stringify(saveData);
        return true;
    } catch (error) {
        console.log(error?.message)
    }
}

export function clearStorage() {
    localStorage.saveData = JSON.stringify({});
    return true;
}

// retrieve data from local storage
export function retrieveFromStorage(key) {
    var saveData = JSON.parse(localStorage.saveData || null) || {};
    return saveData[key] || null;
}

export function promptBox(
    {
        title = "Custom Alert", 
        promptValue,
        defaultValue,
        message = "You can pass a callback function as a callback parameter to define what happens after the confirm button is clicked.", 
        callback,
        btnCancel = "Cancel",
        btnCallback = "Continue"
    }
){

    initPrompt(
        promptValue,
        defaultValue,        
        title,
        message,
        !1,
        !1,
        btnCallback,
        btnCancel,
        function (e, f) {
            callback && callback(e, f)
        },
    );
}

export function alertBox(
    {
        title = "Custom Alert", 
        message = "You can pass a callback function as a callback parameter to define what happens after the confirm button is clicked.", 
        callback,
        btnCancel = "Cancel",
        btnCallback = "Continue"
    }
){

    initConfirm(
        title,
        message,
        !1,
        !1,
        btnCallback,
        btnCancel,
        function (e) {
            callback && callback(e)
        },
    );
}

export function alertNotify({
    message, type, timeout
}){
    initNotify(
        message, type, timeout
    )
}

export function alertAlertify({
    title = "Custom Alert", 
    message = "You can pass a callback function as a callback parameter to define what happens after the confirm button is clicked.", 
    closable,
    btnLabel,
    callback,
}){
    initAlert(
        title,
        message,
        !1,
        !1,
        closable,        
        btnLabel,
        function (e) {
            callback && callback(e)
        },
    );    
}

export function getStatusColor(status){
    switch (status?.toLowerCase()) {
        case "processing":
            return "warning";
        case "pending":
            return "warning";
        case "paid":
            return "success";
        case "success":
            return "success";
        case "accepted":
            return "success";
        case "unpaid":
            return "danger";
        case "failed":
            return "danger";
        case "declined":
            return "danger";
        case "completed":
            return "success";
        default:
            return "primary"
    }
}


export const openInGoogleMapDirection = (pickup, destination) => {
    const link = `https://www.google.com/maps/dir/${pickup?.address?.replace(/ /g,"+")}/${destination?.address?.replace(/ /g,"+")}`;
    window.open(link)
}


export function shortMoney(value, unit="") {
    const num = Number(value);
    if (num >= 1000000000) {
      return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "G"+unit;
    }
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M"+unit;
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K"+unit;
    }
    return num;
  }
  

  export const toDistance = (distance, short=false) => {
      if(short) return shortMoney(distance, "M")
      return (Math.round(distance * 100) / 100)+"kM"
  }
  

  export function scrollTo(id) {
    var elmnt = document.getElementById(id);
    if(elmnt) elmnt.scrollIntoView();
  }

export const FeatherIcon = ({ icon, attr={} }) => {
    try {
        return <i dangerouslySetInnerHTML={{ __html: feather.icons[icon].toSvg(attr) }} />
    } catch (error) {
        return <div/>
    }
}

export const getIcon = (icon, attr={}) => {
    try {
        return feather.icons[icon].toSvg(attr)
    } catch (error) {
        return ""
    }
}

export const copyToClipBoard = (text, callback) => {
    navigator.clipboard && navigator.clipboard.writeText(text).then(
        function () {
            callback && callback()
        },
        function (err) {
            console.error("Async: Could not copy text: ", err);
        },
    );
};


export const paymentIcon = (name) => {
	switch (name) {
		case "online-payment":
			return require("../assets/images/undraw_credit_card_re_blml.svg")
				.default;
		case "cash-payment":
			return require("../assets/images/undraw_wash_hands_nwl2.svg").default;
		case "bank-transfer":
			return require("../assets/images/undraw_mobile_pay_re_sjb8.svg")
				.default;
		case "pay-on-delivery":
			return require("../assets/images/undraw_package_arrived_63rf.svg")
				.default;
		case "enaira-transfer":
			return require("../assets/images/undraw_transfer_money_rywa.svg")
				.default;
		default:
			return require("../assets/images/undraw_bike_ride_7xit.svg").default;
	}
};


export const pageParams = (res) => {
    let current = 1;
    let next = null;
    let previous = null;
    if(res?.previous){
        previous = Number(new URL(res?.previous).searchParams.get("page"));
        current = previous + 1;
    }
    if(res?.next){
        next = Number(new URL(res?.next).searchParams.get("page"));
        current = next - 1;
    }
    return { current, next, previous }
}


export const getNextPage = (data) => {
    let { next = null, previous = null, page = null } = data||{};
	if(previous) page = previous;
	if(next) page = next;
    return page;
}


export const sortArray = (arr, col, reverse=false) => {
    const sort = arr.sort((a, b) => a[col] > b[col] ? 1 : -1)
    return reverse ? sort.reverse() : sort;
}


//<link rel="stylesheet" href="%PUBLIC_URL%/assets/css2/app.css" />


export const appendStyle = (styleToAppend) => {
    const style = document.createElement("link");
    style.rel = "stylesheet";
    style.href = `${window.location.origin}/${styleToAppend}`;
    document.head.appendChild(style);
}

export const appendScript = (scriptToAppend) => {
    const script = document.createElement("script");
    script.src = `${window.location.origin}/${scriptToAppend}`;
    script.async = true;
    document.body.appendChild(script);
}

export const removeScript = (scriptToremove) => {
    let allsuspects=document.getElementsByTagName("script");
    for (let i=allsuspects.length; i>=0; i--){
if (allsuspects[i] && allsuspects[i].getAttribute("src")!==null 
  && allsuspects[i].getAttribute("src").indexOf(`${scriptToremove}`)                !== -1 ){
           allsuspects[i].parentNode.removeChild(allsuspects[i])
        }    
    }
}


export const noAvatar = () => { return  require("../assets/images/placeholder.png").default;}


export const zeroPad = (num, places) => {
    const numZeroes = places - num.toString().length + 1;
    if (numZeroes > 0) {
      return Array(+numZeroes).join("0") + num;
    }
    return num
  }



  export const isEmoji = (emj) => {
    const regex_emoji = /[\p{Extended_Pictographic}\u{1F3FB}-\u{1F3FF}\u{1F9B0}-\u{1F9B3}]/u;
    if(regex_emoji.test(emj) && emj.length < 5) return true;
    return false;
  }